<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Report Definition
      <div slot="right">
        <b-button type="is-normal import-button" @click="redirectToReport"
          >Cancel</b-button
        >
        <b-button
          type="is-primary import-button"
          @click="activateWorkflowDialog"
          v-if="!isViewOnly && isEditAllowed"
          >Save</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <b-collapse class="validation-panel" animation="slide">
        <div class="card validation-card">
          <div class="card-content">
            <div class="columns">
              <div
                class="column columns no-margin"
                v-if="formData && formData.is_follow_up"
              >
                <div class="column">
                  <b-icon icon="file-chart-outline"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div
                    class="columns validation-text-header"
                    v-if="formData && formData.is_follow_up"
                  >
                    Follow Up Report Type
                    <span
                      @click.prevent="
                        redirectToKDB(formData.follow_up_report.url)
                      "
                      v-if="formData && formData.follow_up_report"
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="
                        formData &&
                          formData.is_follow_up &&
                          formData.follow_up_report
                      "
                    >
                      {{ formData.follow_up_report.report_type }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="chart-box-outline"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    {{
                      formData && formData.is_follow_up
                        ? "Parent Report Definition"
                        : "Report Type"
                    }}
                    <span
                      @click.prevent="
                        redirectToReportDefinition(formData.report_definition)
                      "
                      v-if="formData && formData.is_follow_up"
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                    <span
                      @click.prevent="
                        redirectToKDB(formData.follow_up_report.url)
                      "
                      v-else
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="this.$route.params.formData"
                    >
                      {{ this.$route.params.formData.report_type }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-start"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid From
                  </div>
                  <div class="columns">
                    <a
                      ref="#"
                      @click.prevent="setDate('Valid From', 'valid_from')"
                    >
                      <p
                        class="no-padding validation-import-comments"
                        v-if="this.$route.params.formData"
                      >
                        {{ this.$route.params.formData.valid_from }}
                      </p>
                      <p class="no-padding validation-import-comments" v-else>
                        Set Start
                      </p></a
                    >
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-end"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid To
                  </div>
                  <div class="columns">
                    <a ref="#" @click.prevent="setDate('Valid To', 'valid_to')"
                      ><p
                        class="no-padding validation-import-comments"
                        v-if="this.$route.params.formData"
                      >
                        {{ this.$route.params.formData.valid_to }}
                      </p>
                      <p class="no-padding validation-import-comments" v-else>
                        Set Finish
                      </p></a
                    >
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="content-save"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Current Status
                  </div>
                  <div class="columns">
                    <p
                      v-if="formData && !isAdd"
                      class="no-padding validation-import-status"
                    >
                      {{ formData.status }}
                      &nbsp;&nbsp;
                      <span
                        v-if="formData.status == 'Rejected'"
                        class="additional-info"
                      >
                        <b-tooltip
                          type="is-primary"
                          :label="formData.comment_for_rejection"
                          multilined
                        >
                          <i class="mdi mdi-information"></i>
                        </b-tooltip>
                      </span>
                    </p>
                    <p v-else class="no-padding validation-import-comments">
                      Unsaved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
    <section class="section is-main-section no-padding-top" v-if="formData">
      <div class="report-definition-scope">
        <div class="scope-bundle" v-if="formData.country_name">
          <div class="scope">
            <div class="country-with-flag">
              <country-flag
                :country="formData.country_code"
                size="small"
                v-if="formData.country_code"
              />
              <span class="scope-text">{{ formData.country_name }}</span>
            </div>
          </div>
          <hr class="scope-hr" />
        </div>
        <div class="scope-bundle" v-if="formData.scheme_name">
          <div class="scope">
            <span class="scope-text">{{ formData.scheme_name }}</span>
          </div>
          <hr class="scope-hr" />
        </div>
        <div class="scope-bundle" v-if="formData.stream_name">
          <div class="scope">
            <span class="scope-text">{{ formData.stream_name }}</span>
          </div>
          <hr class="scope-hr" />
        </div>
        <ul class="scope-rule-list">
          <li v-for="(value, index) in scopeData" :key="index" class="scope">
            <span v-on:click="showRule(value)"
              ><a href="#">{{ value.name }}</a></span
            >
          </li>
        </ul>
        <hr />
      </div>
      <div class="scope-bundle">
        <h3>Categories</h3>
        <ul class="categories enable-select-text">
          <li
            v-for="(category, index) in categories"
            :key="index"
            class="category"
          >
            <b :title="'ID: ' + category.id">{{ category.name }}</b>
            <span
              v-if="category.id && !isViewOnly"
              v-on:click="addRuletoCategory(category)"
              class="float-right"
              ><a href="#"><b-icon icon="plus"/></a
            ></span>
            <ul v-if="category.rules && category.rules.length > 0">
              <hr class="scope-hr" />
              <li
                v-for="(value, index) in category.rules"
                :key="index"
                class="scope rule-list"
              >
                <span class="rule">
                  <b-icon
                    v-if="value.priority === 'low'"
                    icon="chevron-double-down"
                    class="rule-priority-down"
                  />
                  <b-icon
                    v-if="value.priority === 'high'"
                    icon="chevron-double-up"
                    class="rule-priority-up"
                  />
                  <a href="#" @click.prevent.stop="showRule(value)">{{
                    value.name
                  }}</a></span
                >
                <span class="rule-icons" v-if="!isViewOnly">
                  <a
                    href="#"
                    v-if="index != 0 && category.rules.length > 1"
                    @click.prevent.stop="moveElement(value, category, null, -1)"
                    ><b-icon icon="arrow-up-circle"
                  /></a>
                  <a
                    href="#"
                    v-if="
                      index != category.rules.length - 1 &&
                        category.rules.length > 1
                    "
                    @click.prevent.stop="moveElement(value, category, null, 1)"
                    ><b-icon icon="arrow-down-circle"
                  /></a>
                  <a
                    href="#"
                    @click.prevent.stop="deselectRule(value, category, null)"
                    ><b-icon icon="minus-circle"
                  /></a>
                </span>
              </li>
            </ul>
            <hr class="scope-hr" />
            <ul class="sub-categories">
              <li
                v-for="(subCategory, index) in category.sub_categories"
                :key="index"
                class="sub-category"
              >
                <b :title="'ID: ' + subCategory.id">{{ subCategory.name }}</b>
                <span
                  v-if="!isViewOnly"
                  v-on:click="addRuletoCategory(category, subCategory)"
                  class="float-right"
                  ><a href="#"><b-icon icon="plus"/></a
                ></span>
                <hr class="scope-hr" />
                <ul v-if="subCategory.rules">
                  <li
                    v-for="(value, index) in subCategory.rules"
                    :key="index"
                    class="scope rule-list"
                  >
                    <span class="rule">
                      <b-icon
                        v-if="value.priority == 'low'"
                        icon="chevron-double-down"
                        class="rule-priority-down"
                      />
                      <b-icon
                        v-if="value.priority == 'high'"
                        icon="chevron-double-up"
                        class="rule-priority-up"
                      />
                      <a href="#" @click.prevent.stop="showRule(value)">{{
                        value.name
                      }}</a></span
                    >
                    <span class="rule-icons" v-if="!isViewOnly">
                      <a
                        href="#"
                        v-if="index != 0 && subCategory.rules.length > 1"
                        @click.prevent.stop="
                          moveElement(value, category, subCategory, -1)
                        "
                        ><b-icon icon="arrow-up-circle"
                      /></a>
                      <a
                        href="#"
                        v-if="
                          index != subCategory.rules.length - 1 &&
                            subCategory.rules.length > 1
                        "
                        @click.prevent.stop="
                          moveElement(value, category, subCategory, 1)
                        "
                        ><b-icon icon="arrow-down-circle"
                      /></a>
                      <a
                        href="#"
                        @click.prevent.stop="
                          deselectRule(value, category, subCategory)
                        "
                        ><b-icon icon="minus-circle"
                      /></a>
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <br /><br />
      <div
        class="columns"
        v-if="formData && formData.status == 'Sent for Approval' && !isViewOnly"
      >
        <div class="column">
          <ul class="context-options-left">
            <li>
              <b-button
                slot="right"
                native-type="submit"
                type="is-success"
                @click="addOrEditReport('confirm')"
              >
                Approve
              </b-button>
            </li>
            <li>
              <b-button
                slot="right"
                @click="rejectBtnAction"
                type="is-danger"
                class="deactivateBtn"
              >
                Reject
              </b-button>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <SetTimeModal
      :is-active="isModalActive"
      :modalHeader="setModalHeader"
      :formData="formDataDate"
      @confirm="setConfirmTime"
      @cancel="exitModal"
    />
    <select-rule
      v-if="formData.stream"
      :is-active="isSelectRuleModalActive"
      :show-priority="true"
      @confirm="addSelecedRule"
      @cancel="closeSelectRuleModal"
      :stream="formData.stream"
    />
    <view-rules
      :is-active="isViewModalActive"
      :formData="viewRule"
      @cancel="cancelViewRule"
      :show-edit-button="false"
      :rule-tags="ruleTags"
    />
    <workflow-dialog
      :is-active="isWorkflowDialogActive"
      @submit="addOrEditReport"
      @cancel="closeWorkflowDialog"
    />

    <report-definition-validity-dialog
      :is-active="isReportDefintionValidityDialogActive"
      :message="validityMessage"
      @submit="forceAddOrRefreshReport"
      @cancel="closeReportDefintionValidityDialog"
    />

    <show-comments
      :is-active="isShowCommentActive"
      @cancel="closeShowComment"
      :data="formData"
    />
    <b-modal v-model="isRejectModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-reject">
            You are rejecting the changes
          </p>
        </header>
        <section class="modal-card-body">
          <b-field label="Please describe the reasons">
            <b-input
              maxlength="500"
              type="textarea"
              v-model="comment"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Close"
            class="reject-modal-close-button"
            @click="isRejectModalActive = false"
          />
          <b-button label="Reject" type="is-danger" @click="rejectScope" />
        </footer>
      </div>
    </b-modal>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import RulesManagerService from "../../services/RulesManagerService";
import { mapGetters } from "vuex";
import SetTimeModal from "@/components/RulesManager/SetTimeModal.vue";
import UtilityMixin from "@/mixins/UtilityMixin";
import SelectRule from "@/components/RulesManager/SelectRule.vue";
import ViewRules from "@/components/RulesManager/ViewRules.vue";
import WorkflowDialog from "@/components/RulesManager/WorkflowDialog.vue";
import ShowComments from "@/components/RulesManager/ShowComments.vue";
import ReportDefinitionValidityDialog from "@/components/RulesManager/ReportDefinitionValidityDialog.vue";
import { UserGroup } from "@/services/UserGroups";
import * as dayjs from "dayjs";
export default {
  name: "ReportDefinition",
  components: {
    HeroBar,
    TitleBar,
    SetTimeModal,
    SelectRule,
    ViewRules,
    WorkflowDialog,
    ShowComments,
    ReportDefinitionValidityDialog
  },
  mixins: [UtilityMixin],
  props: {
    isViewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCategory: null,
      selectedSubCategory: null,
      hover: false,
      viewRule: {},
      data: [],
      formData: [],
      isDataLoading: false,
      isLoading: false,
      isModalActive: false,
      isViewModalActive: false,
      isSelectRuleModalActive: false,
      selectedRules: [],
      action: null,
      isAdd: this.$route.params.isAdd,
      categories: this.$route.params.categories,
      scopeData: this.$route.params.scopeData,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      RulesManagerService: new RulesManagerService(),
      valid_to: null,
      valid_from: null,
      setModalKey: null,
      setModalHeader: null,
      formDataDate: null,
      isWorkflowDialogActive: false,
      isShowCommentActive: false,
      isRejectModalActive: false,
      isReportDefintionValidityDialogActive: false,
      validityMessage: null,
      workflow: null,
      comment: null,
      ruleTags: []
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Rules Manager" },
        { url: "/rulesManager/reportDefinitions", name: "Report Definitions" },
        { url: "#", name: "Report Definition" }
      ];
    },
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.checkExternalPermission();
    this.getReportDefinitionById();
    this.fetchRuleTags();
  },

  methods: {
    redirectToKDB(url) {
      window.open(url, "_blank");
    },
    redirectToReportDefinition(id) {
      if (!id) return;

      // Get the base URL from the current location
      const baseUrl = window.location.origin;

      // Construct the complete URL manually to ensure it's correct
      const url = `${baseUrl}/rulesManager/reportDefinition/${id}/view`;

      // Open in a new tab with the complete URL
      window.open(url, "_blank");
    },
    fetchRuleTags() {
      this.RulesManagerService.getRulesTags().subscribe(response => {
        this.ruleTags = response;
      });
    },
    closeShowComment() {
      this.isShowCommentActive = false;
    },
    showComment() {
      this.isShowCommentActive = true;
    },
    rejectBtnAction() {
      this.isRejectModalActive = true;
    },
    rejectScope() {
      this.formData[`comment`] = this.comment;
      this.isRejectModalActive = false;
      this.addOrEditReport("reject");
    },
    activateWorkflowDialog() {
      this.isWorkflowDialogActive = true;
    },
    activateReportDefintionValidityDialog() {
      this.isReportDefintionValidityDialogActive = true;
    },
    closeReportDefintionValidityDialog() {
      this.formData.force_update = false;
      this.isReportDefintionValidityDialogActive = false;
    },
    closeWorkflowDialog() {
      this.isWorkflowDialogActive = false;
    },
    forceAddOrRefreshReport(value) {
      if (value == "refresh") {
        this.refreshNewCategories();
      } else if (value == "reload") {
        this.formData.force_update = true;
        this.addReport(this.workflow);
      }
      return true;
    },
    moveElement(rule, category, subCategory, direction) {
      const categoryIndex = this.categories.indexOf(category);
      if (subCategory) {
        const subCatIndex = this.categories[categoryIndex][
          "sub_categories"
        ].indexOf(subCategory);
        const subIndex = this.categories[categoryIndex]["sub_categories"][
          subCatIndex
        ]["rules"].indexOf(rule);
        this.categories[categoryIndex]["sub_categories"][subCatIndex][
          "rules"
        ].splice(
          subIndex + direction,
          0,
          this.categories[categoryIndex]["sub_categories"][subCatIndex][
            "rules"
          ].splice(subIndex, 1)[0]
        );
      } else {
        const index = category.rules.indexOf(rule);
        if (index > -1) {
          this.categories[categoryIndex]["rules"].splice(
            index + direction,
            0,
            this.categories[categoryIndex]["rules"].splice(index, 1)[0]
          );
        }
      }
      this.categories = [...this.categories];
    },
    deselectRule(rule, category, subCategory) {
      const categoryIndex = this.categories.indexOf(category);
      if (subCategory) {
        const subCatIndex = this.categories[categoryIndex][
          "sub_categories"
        ].indexOf(subCategory);
        const index = this.categories[categoryIndex]["sub_categories"][
          subCatIndex
        ]["rules"].indexOf(rule);
        this.categories[categoryIndex]["sub_categories"][subCatIndex][
          "rules"
        ].splice(index, 1);
      } else {
        const index = category.rules.indexOf(rule);
        if (index > -1) {
          this.categories[categoryIndex]["rules"].splice(index, 1);
        }
      }
      this.categories = [...this.categories];
    },
    showRule(value) {
      const tagSelected = this.ruleTags
        .filter(item => (value["tags"] ? value["tags"].includes(item.id) : ""))
        .map(a => a.name)
        .toString();

      value["tags"] = tagSelected == "" ? "NA" : tagSelected;
      this.isViewModalActive = true;
      this.viewRule = value;
    },
    cancelViewRule() {
      this.isViewModalActive = false;
    },

    addRuletoCategory(category, subCategory = "") {
      this.isSelectRuleModalActive = true;
      this.selectedCategory = category;
      this.selectedSubCategory = subCategory;
    },
    closeSelectRuleModal() {
      this.isSelectRuleModalActive = false;
    },
    setConfirmTime(value) {
      this.formData[`${this.setModalKey}`] = new Date(value).toLocaleDateString(
        "fr-CA"
      );

      this.isModalActive = false;
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt == " - ") {
        return newDate;
      }
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    getReportDefinitionById() {
      if (
        this.$route.params.formData &&
        this.$route.params.formData.report_definition
      ) {
        this.isLoading = true;
        this.RulesManagerService.getViewReportDefinitionById(
          this.$route.params.formData.report_definition
        ).subscribe(response => {
          this.formData = this.$route.params.formData;
          if (response.table_config && response.table_config != null) {
            this.$router.push({
              path:
                "/rulesManager/tabularReportDefinition/" +
                this.$route.params.formData.report_definition +
                "/copy",
              query: { isCopy: true }
            });
            return;
          }
          this.fetchScopes(response);
          if (!this.formData.follow_up_report) {
            this.formData.follow_up_report = {};
          }
          this.formData.follow_up_report.url = response.report_url;
          //this.selectedRules = this.formData.rule;
          this.categories = response.categories;
          this.categories.forEach((value, index) => {
            if (value.rules.length > 0 && this.formData.status != "Approved") {
              this.categories[index].rules = value.rules.filter(
                value => value.active
              );
            }
            if (value.sub_categories.length > 0) {
              value.sub_categories.forEach((value2, index2) => {
                if (
                  value2.rules.length > 0 &&
                  this.formData.status != "Approved"
                ) {
                  this.categories[index].sub_categories[
                    index2
                  ].rules = value2.rules.filter(value => value.active);
                }
              });
            }
          });
          this.formData.updated_at
            ? (this.formData.updated_at = dayjs(
                this.formData.updated_at
              ).format("YYYY-MM-DD, HH:mm"))
            : null;
          this.isLoading = false;
        }, this.handleEditApiError);
      } else {
        this.redirectToReport();
      }
    },
    getClearFormObject() {
      this.formData = [];
    },
    redirectToReport() {
      this.formData = [];

      // First try to navigate using Vue Router
      try {
        this.$router.push({
          name: "rulesManager.reportDefinitions"
        });
      } catch (error) {
        // If Vue Router navigation fails, use a direct URL approach
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/rulesManager/reportDefinitions`;
      }
    },
    addOrEditReport(workflow) {
      this.workflow = workflow;
      this.closeWorkflowDialog();
      if (this.formData.valid_to && this.formData.valid_from) {
        this.addReport(workflow);
      } else {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select a date for 'Valid from' / 'Valid to'",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },

    refreshNewCategories() {
      this.RulesManagerService.getReportCategories(this.formData).subscribe(
        response => {
          const categories = response;
          categories.categories_fees.forEach(e => (e.rules = []));
          this.categories = categories.categories_fees;
          this.formData.valid_from_old = this.formData.valid_from;
          this.formData.valid_to_old = this.formData.valid_to;
          this.closeReportDefintionValidityDialog();
        },
        () => {
          alert(
            "Could not fetch the valid reporting categories with the selected date range!"
          );
        }
      );
    },
    addReport(workflow) {
      this.formData.categories = this.categories;
      this.RulesManagerService.addReportDefinition(
        this.formData,
        workflow
      ).subscribe(response => {
        const categories = response.categories_fees;
        if (
          (categories && categories.length) ||
          response.cat_removed ||
          response.cat_added
        ) {
          if (categories.length) {
            let messageBody = "";
            if (response.cat_removed) {
              messageBody =
                "<strong>Following  categories do not  match the validity of the report definition.</strong>";
              messageBody +=
                "<strong>Click cancel to change the validity, continue to save the report defintion  otherwise refresh to remove the categories.</strong><br>";
            } else if (categories.cat_added) {
              messageBody =
                "<strong>Following categories do not  match the validity of the report definition.</strong>";
              messageBody +=
                "<strong>Click cancel to change the validity, continue to save the report defintion otherwise refresh to load the changed categories.</strong><br>";
            }
            messageBody += "<ul>";

            categories.forEach(function(item, index) {
              messageBody += "<li>";
              messageBody += index + 1 + ". " + item.category;
              if (item.sub_category != "N/A") {
                messageBody += ": " + item.sub_category;
              }
              messageBody +=
                " " + item.valid_from + " to " + item.valid_to + "</li>";
            });
            messageBody + "</ul>";
            this.validityMessage = messageBody;
            this.activateReportDefintionValidityDialog();
          } else {
            const messageBody =
              "No matching reporting categories exist. Please adjust the report validity.";
            this.$buefy.dialog.alert({
              title: "Error",
              message: messageBody,
              type: "is-danger"
            });
          }
        } else {
          this.$buefy.toast.open({
            message: "Data is added successfully!",
            type: "is-success"
          });
          this.redirectToReport();
        }
      }, this.handleApiError);
    },

    exitModal() {
      this.setModalHeader = null;
      this.setModalKey = null;
      this.isModalActive = false;
    },

    setDate(value, key) {
      if (!this.isViewOnly && this.isEditAllowed) {
        this.setModalHeader = value;
        this.setModalKey = key;
        this.isModalActive = true;
        this.formDataDate = this.convertToDate(
          this.formData[`${this.setModalKey}`]
        );
      }
    },
    handleEditApiError(reason) {
      this.isLoading = false;
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.redirectToReport()
      });
    },
    handleApiError(reason) {
      this.isLoading = false;
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
        //onConfirm: () => this.redirectToReport()
      });
    },
    addSelecedRule(rule, priority = "") {
      rule.priority = priority;
      const index = this.categories.findIndex(
        e => e.id === this.selectedCategory.id
      );
      if (index > -1) {
        const subCatIndex =
          this.categories[index]["sub_categories"] &&
          this.categories[index]["sub_categories"].findIndex(
            e => e.id === this.selectedSubCategory.id
          );
        if (subCatIndex > -1) {
          if (this.categories[index]["sub_categories"][subCatIndex]["rules"]) {
            this.categories[index]["sub_categories"][subCatIndex]["rules"].push(
              rule
            );
          } else {
            this.categories[index]["sub_categories"][subCatIndex]["rules"] = [];
            this.categories[index]["sub_categories"][subCatIndex]["rules"].push(
              rule
            );
          }
        } else {
          if (this.categories[index]["rules"]) {
            this.categories[index]["rules"].push(rule);
          } else {
            this.categories[index]["rules"] = [];
            this.categories[index]["rules"].push(rule);
          }
        }
      }
      this.isSelectRuleModalActive = false;
    },

    fetchScopes(formData) {
      this.RulesManagerService.getFilterScopeData(formData).subscribe(
        response => {
          this.scopeData = response.results; // need to change this api in future and instead of paginated scope need all the scope
        }
      );
    }
  }
};
</script>
